export default __webpack_public_path__ + "static/media/registerAsIndividual.f21b1ea1.svg";